import React, {useEffect, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import axios from 'axios';
import Cookies from 'js-cookie';

import * as constants from 'constants/index.js';

import InputCustom from 'views/pages/components/InputCustom';
import TableCustom from 'views/pages/components/TableCustom';

import {Card, CardBody, CardHeader, Col, Container, Modal, Row,} from 'reactstrap';

import {deletee, hasPermission} from 'views/policies/LeadSourcePolicy';
import {ButtonContainer} from "@pages/reusable-components/styled-components";
import IcoMoon from "react-icomoon";
import IconSet from "@assets/selection.json";
import notify from '@utils/notify';

export default function Sources() {
  const permissions = useSelector(state => state.getState).permissions;

  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(true);
  const [sources, setSources] = useState([]);

  const [source, setSource] = useState('');
  const [sourceModal, setSourceModal] = useState({
    show: false,
    header: '',
    division: ''
  })

  const [deleteModal, setDeleteModal] = useState({
    show: false,
    header: '',
    onClick: null
  })

  const [errors, setErrors] = useState('');

  useEffect(() => {
    const grs_token = Cookies.get('grs_token')
    setToken(grs_token)

    const source = axios.CancelToken.source()

    const fetchData = async () => {
      try {
        const response = await axios({
          method: 'GET',
          url: `${constants.API_URL}/lead-sources`,
          headers: {
            Authorization: `Bearer ${grs_token}`,
          },
          cancelToken: source.token,
        })
        console.log('response :: ', response.data)
        const data = response.data
        
        setSources(data.data.items)

        setTimeout(() => {
          setLoading(false)
        }, 500)
      } catch (error) {
        setLoading(false)
        if (axios.isCancel(error)) {
          console.log('Request canceled :: ', error)
        } else {
          console.error('error :: ', error)
          notify.warning(error.response && error.response.data ? error.response.data.message : error.response ? error.response.statusText : 'Error Occurred!')
        }
      }
    }

    fetchData()

    return () => {
      source.cancel()
    }
  }, [])

  const addSource = () => {
    axios({
      method: 'POST',
      url: `${constants.API_URL}/lead-sources`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: source
    })
      .then(response => {
        let data = response.data
        setSources(prevState => ([
          ...prevState,
          ...[data.data],
        ]))
        notify.success(data.message)
        setErrors('')
        setSourceModal({
          ...sourceModal,
          show: false
        })
      })
      .catch(error => {
        console.error('error :: ', error)
        if (error.response && error.response.data.errors) {
          let errors = error.response.data.errors
          setErrors(errors)
          return
        }
        setSourceModal({
          ...sourceModal,
          show: false
        })
        notify.warning(error.response ? error.response.statusText : 'Error occurred!')
      })
  }

  const updateSource = () => {
    axios({
      method: 'PUT',
      url: `${constants.API_URL}/lead-sources/${source.id}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: source
    })
      .then(response => {
        console.log('res :: ', response.data)
        let data = response.data
        const updatedIdx = sources.findIndex(item=>item.id === source.id)
        const updatedSources = [...sources];
        updatedSources[updatedIdx] = data.data;
        setSources(updatedSources);
        notify.success(data.message)
        setErrors('')
        setSourceModal({
          ...sourceModal,
          show: false
        })
      })
      .catch(error => {
        console.error('error :: ', error)
        if (error.response && error.response.data.errors) {
          let errors = error.response.data.errors
          setErrors(errors)
          return
        }
        setSourceModal({
          ...sourceModal,
          show: false
        })
        notify.warning(error.response ? error.response.statusText : 'Error occurred!')
      })
  }

  const deleteSource = (sourceId) => {
    axios({
      method: 'DELETE',
      url: `${constants.API_URL}/lead-sources/${sourceId}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(response => {
        let data = response.data
        setSources(prevState => [...prevState.filter(item=>item.id !== sourceId)]);
        notify.success(data.message)
        setDeleteModal({
          ...deleteModal,
          show: false
        })
      })
      .catch(error => {
        console.error('error :: ', error)
        setDeleteModal({
          ...deleteModal,
          show: false
        })
        notify.warning(error.response ? error.response.statusText : 'Error occurred!')
      })
  }

  return (
    <>
      <Container className="admin-main-body" fluid >
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col xs={8}>
                    <h1 className="mb-0">Lead Sources</h1>
                    <p className="text-sm mb-0">Lead Sources management</p>
                  </Col>
                  <Col xs={4} className="text-right">
                    {hasPermission(permissions, 'create-lead-sources') &&
                      <ButtonContainer reverse onClick={() => {
                        setSource('')
                        setErrors('')
                        setSourceModal({
                          show: true,
                          header: 'Lead source details'.toUpperCase(),
                          division: 'create'
                        })
                      }}>Add new</ButtonContainer>}
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <TableCustom 
                  loading={loading}
                  keyField={`id`}
                  searchField={false}
                  items={sources}
                  columns={[
                    {
                      dataField: "name",
                      text: "Name",
                      sort: true
                    },
                    {
                      dataField: "",
                      text: "Action",
                      style: {
                        textAlign: 'right'
                      },
                      formatter: (rowContent, row) => {
                        return (
                          <>
                            <IcoMoon
                                className={'cursor-pointer'}
                                iconSet={IconSet}
                                icon={'edit'}
                                size={24}
                                onClick={() => {
                                  setSource(row)
                                  setErrors('')
                                  setSourceModal({
                                    ...sourceModal,
                                    show: true,
                                    header: 'Edit lead source details'.toUpperCase(),
                                    division: 'update'
                                  })
                                }}
                             />

                                {deletee(permissions, row) &&
                                <IcoMoon
                                    className={'cursor-pointer'}
                                    iconSet={IconSet}
                                    icon={'delete_outline'}
                                    size={24}
                                    onClick={() => setDeleteModal({
                                      ...deleteModal,
                                      show: true,
                                      header: 'Delete lead source',
                                      onClick: () => deleteSource(row.id)
                                    })}
                                />
                             }
                          </>
                        )
                      }
                    }
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        {/* Add/Edit Lead Source Modal */}
        <Modal
          isOpen={sourceModal.show}
          toggle={() => setSourceModal({
            ...sourceModal,
            show: false
          })}
          className="modal-dialog-centered"
        >
          <div className="modal-header">
            <h6 className="modal-title main-color">{sourceModal.header}</h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setSourceModal({
                ...sourceModal,
                show: false
              })}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            <InputCustom 
              label={`Name`}
              value={source && source.name? source.name: ''}
              onChange={e => setSource({
                ...source,
                name: e.target.value,
              })}
              invalid={errors && errors.name? true: false}
              errorMessage={errors.name}
            />
          </div>
          <div className="modal-footer">
            <ButtonContainer
                onClick={() => setSourceModal({
                  ...sourceModal,
                  show: false
                })}
            >
              {`Close`}
            </ButtonContainer>
            <ButtonContainer
              reverse
              onClick={() => sourceModal.division === 'create'? addSource(): updateSource()}
            >
              {`Save`}
            </ButtonContainer>
          </div>
        </Modal>
        {/* Delete source */}
        <Modal
          isOpen={deleteModal.show}
          toggle={() => setDeleteModal({
            ...deleteModal,
            show: false
          })}
          className="modal-dialog-centered"
        >
          <div className="modal-header">
            <h6 className="modal-title">{deleteModal.header}</h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setDeleteModal({
                ...deleteModal,
                show: false
              })}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            {`Are you sure you want to delete this lead source?`}
          </div>
          <div className="modal-footer">
            <ButtonContainer
              reverse
              onClick={deleteModal.onClick}
            >
              {`Delete`}
            </ButtonContainer>
            <ButtonContainer
              onClick={() => setDeleteModal({
                ...deleteModal,
                show: false
              })}
            >
			        {`Close`}
            </ButtonContainer>
          </div>
        </Modal>
      </Container>
    </>
  )
}